// extracted by mini-css-extract-plugin
export default {"valid":"BatchItemIsValidChip_valid__Bl7Cz","invalid":"BatchItemIsValidChip_invalid__s7M2Z","unknown":"BatchItemIsValidChip_unknown__aNra5"};